// src/pages/ImageUploadPanel.js
import React, { useState, useEffect } from "react";
import axios from "../api/axios";

const ImageUploadPanel = () => {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);

  // Estados para imagen de Categoría
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryFile, setCategoryFile] = useState(null);

  // Estados para imagen de Marca
  const [selectedBrand, setSelectedBrand] = useState("");
  const [brandFile, setBrandFile] = useState(null);

  // Estados para imagen principal de Producto
  const [productMainName, setProductMainName] = useState("");
  const [productMainFile, setProductMainFile] = useState(null);

  // Estados para imagen extra de Producto
  const [productExtraName, setProductExtraName] = useState("");
  const [productExtraFile, setProductExtraFile] = useState(null);

  // Estado para el banner de AboutUS
  const [aboutBannerFile, setAboutBannerFile] = useState(null);

  const [message, setMessage] = useState("");

  // Obtener categorías y marcas desde el backend al montar el componente
  useEffect(() => {
    const fetchCategoriesAndBrands = async () => {
      try {
        const catRes = await axios.get("/categories");
        setCategories(catRes.data);
        const brandRes = await axios.get("/brands");
        setBrands(brandRes.data);
      } catch (error) {
        console.error("Error obteniendo categorías o marcas:", error);
      }
    };
    fetchCategoriesAndBrands();
  }, []);

  // Funciones para subir cada tipo de imagen

  const handleUploadCategory = async () => {
    if (!selectedCategory || !categoryFile) {
      return setMessage("Selecciona una categoría y una imagen para subir.");
    }
    try {
      const formData = new FormData();
      formData.append("categoryName", selectedCategory);
      formData.append("image", categoryFile);
      const res = await axios.post("/images/uploadCategory", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(res.data.message || "Imagen de categoría subida con éxito.");
    } catch (error) {
      console.error("Error subiendo imagen de categoría:", error);
      setMessage("Error subiendo imagen de categoría.");
    }
  };

  const handleUploadBrand = async () => {
    if (!selectedBrand || !brandFile) {
      return setMessage("Selecciona una marca y una imagen para subir.");
    }
    try {
      const formData = new FormData();
      formData.append("brandName", selectedBrand);
      formData.append("image", brandFile);
      const res = await axios.post("/images/uploadBrand", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(res.data.message || "Imagen de marca subida con éxito.");
    } catch (error) {
      console.error("Error subiendo imagen de marca:", error);
      setMessage("Error subiendo imagen de marca.");
    }
  };

  const handleUploadProductMain = async () => {
    if (!productMainName || !productMainFile) {
      return setMessage("Ingresa un nombre y selecciona una imagen para subir.");
    }
    try {
      const formData = new FormData();
      formData.append("filename", productMainName);
      formData.append("image", productMainFile);
      const res = await axios.post("/images/uploadProductMain", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(res.data.message || "Imagen principal de producto subida con éxito.");
    } catch (error) {
      console.error("Error subiendo imagen principal:", error);
      setMessage("Error subiendo imagen principal.");
    }
  };

  const handleUploadProductExtra = async () => {
    if (!productExtraName || !productExtraFile) {
      return setMessage("Ingresa un nombre y selecciona una imagen para subir.");
    }
    try {
      const formData = new FormData();
      formData.append("filename", productExtraName);
      formData.append("image", productExtraFile);
      const res = await axios.post("/images/uploadProductExtra", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(res.data.message || "Imagen extra de producto subida con éxito.");
    } catch (error) {
      console.error("Error subiendo imagen extra:", error);
      setMessage("Error subiendo imagen extra.");
    }
  };
  const handleUploadAboutBanner = async () => {
    if (!aboutBannerFile) {
      return setMessage("Selecciona una imagen para subir como banner de 'Sobre Nosotros'.");
    }
    try {
      const formData = new FormData();
      formData.append("image", aboutBannerFile);
      const res = await axios.post("/images/uploadAboutBanner", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(res.data.message || "Banner de 'Sobre Nosotros' subido con éxito.");
    } catch (error) {
      console.error("Error subiendo banner de 'Sobre Nosotros':", error);
      setMessage("Error subiendo banner de 'Sobre Nosotros'.");
    }
  };

  return (
    <div className="flex">
      <div className="flex-1 ml-64 p-6 bg-gray-100 min-h-screen">
        <h1 className="text-3xl font-bold mb-6 text-center">Subir Imágenes</h1>
        {message && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
            {message}
          </div>
        )}

        {/* Tarjeta: Imagen de Categoría */}
        <div className="bg-white shadow-md rounded-lg p-6 mb-6 max-w-md mx-auto border-l-4 border-yellow-500">
          <h2 className="text-xl font-bold mb-4">Subir Imagen de Categoría</h2>
          <label className="block mb-2">Selecciona una categoría</label>
          <select
            className="border p-2 mb-4 w-full"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">-- Selecciona --</option>
            {categories.map((cat, i) => (
              <option key={i} value={cat.name}>
                {cat.name}
              </option>
            ))}
          </select>
          <input type="file" className="mb-4" onChange={(e) => setCategoryFile(e.target.files[0])} />
          <button
            onClick={handleUploadCategory}
            className="bg-yellow-600 text-white px-4 py-2 rounded hover:bg-yellow-700"
          >
            Subir Imagen de Categoría
          </button>
        </div>

        {/* Tarjeta: Imagen de Marca */}
        <div className="bg-white shadow-md rounded-lg p-6 mb-6 max-w-md mx-auto border-l-4 border-indigo-500">
          <h2 className="text-xl font-bold mb-4">Subir Imagen de Marca</h2>
          <label className="block mb-2">Selecciona una marca</label>
          <select
            className="border p-2 mb-4 w-full"
            value={selectedBrand}
            onChange={(e) => setSelectedBrand(e.target.value)}
          >
            <option value="">-- Selecciona --</option>
            {brands.map((b, i) => (
              <option key={i} value={b.name}>
                {b.name}
              </option>
            ))}
          </select>
          <input type="file" className="mb-4" onChange={(e) => setBrandFile(e.target.files[0])} />
          <button
            onClick={handleUploadBrand}
            className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
          >
            Subir Imagen de Marca
          </button>
        </div>

        {/* Tarjeta: Imagen Principal de Producto */}
        <div className="bg-white shadow-md rounded-lg p-6 mb-6 max-w-md mx-auto border-l-4 border-blue-500">
          <h2 className="text-xl font-bold mb-4">Subir Imagen Principal de Producto</h2>
          <label className="block mb-2">Nombre de la imagen (Ej: Cama_de_gato.jpg)</label>
          <input
            type="text"
            className="border p-2 mb-4 w-full"
            placeholder="Nombre de la imagen"
            value={productMainName}
            onChange={(e) => setProductMainName(e.target.value)}
          />
          <input type="file" className="mb-4" onChange={(e) => setProductMainFile(e.target.files[0])} />
          <button
            onClick={handleUploadProductMain}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Subir Imagen Principal
          </button>
        </div>

        {/* Tarjeta: Imagen Extra de Producto */}
        <div className="bg-white shadow-md rounded-lg p-6 mb-6 max-w-md mx-auto border-l-4 border-green-500">
          <h2 className="text-xl font-bold mb-4">Subir Imagen Extra de Producto</h2>
          <label className="block mb-2">Nombre de la imagen (Ej: Imagen_1_cama_gato.jpg)</label>
          <input
            type="text"
            className="border p-2 mb-4 w-full"
            placeholder="Nombre de la imagen"
            value={productExtraName}
            onChange={(e) => setProductExtraName(e.target.value)}
          />
          <input type="file" className="mb-4" onChange={(e) => setProductExtraFile(e.target.files[0])} />
          <button
            onClick={handleUploadProductExtra}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Subir Imagen Extra
          </button>
        </div>
        {/* Tarjeta: Banner de "Sobre Nosotros" */}
        <div className="bg-white shadow-md rounded-lg p-6 mb-6 max-w-md mx-auto border-l-4 border-purple-500">
          <h2 className="text-xl font-bold mb-4">Subir Banner de "Sobre Nosotros"</h2>
          <input
            type="file"
            className="mb-4"
            onChange={(e) => setAboutBannerFile(e.target.files[0])}
          />
          <button
            onClick={handleUploadAboutBanner}
            className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
          >
            Subir Banner
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageUploadPanel;
